import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col, Alert, Spinner } from "@themesberg/react-bootstrap";
import axios from "axios";
import { BASE_URL } from "../../constants";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css'; 
const EditShelterModal = ({ show, onHide, shelterId, onShowAlert, setRooms }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editForm, setEditForm] = useState({
    name: "",
    address: {
      street: "",
      city: "",
      postalCode: "",
      country: ""
    },
    contactInfo: { phone: "", email: "" },
    costPerOccupant: "",
    stateCoverage: "",
  });


  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/users`);
        // Filter users where isAdmin is true
        const admins = response.data.filter(user => user.isAdmin);
        setUsers(admins);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    if (shelterId && show) {
      axios
        .get(`${BASE_URL}/shelters/${shelterId}`)
        .then((response) => {
          const shelterData = response.data;
          setEditForm({
            name: shelterData.name || "",
            address: {
              street: shelterData.address?.street || "",
              city: shelterData.address?.city || "",
              postalCode: shelterData.address?.postalCode || "",
              country: shelterData.address?.country || "",
            },
            contactInfo: {
              phone: shelterData.contactInfo?.phone || "",
              email: shelterData.contactInfo?.email || ""
            },
           
            costPerOccupant: shelterData.costPerOccupant || "",
            stateCoverage: shelterData.stateCoverage || "",
          });
          
          
        })
        .catch((error) => {
          console.error("Error fetching shelter data:", error);
        });
    }
  }, [shelterId, show]);

  const handleSaveChanges = async () => {
    setLoading(true);
    try {
      const response = await axios.put(`${BASE_URL}/shelters/${shelterId}`, editForm);
  
      if (response.status !== 200) {
        throw new Error("Failed to update shelter");
      }
  
      setRooms((prevRooms) =>
        prevRooms.map((room) =>
          room.id === shelterId ? { ...room, ...editForm } : room
        )
      );
  
      setLoading(false);              // Stop loading first
      onShowAlert("Shelter updated successfully!", "success");  // Then show toast
  
      setTimeout(() => {
        onHide();                    // Close modal after a delay
      }, 2000);
  
    } catch (error) {
      console.error("Error updating shelter:", error);
  
      setLoading(false);              
      onShowAlert("Failed to update shelter. Please try again.", "danger"); 
  
      setTimeout(() => {
        onHide();                   
      }, 2000);
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name.startsWith("address.")) {
      const key = name.split(".")[1];
      setEditForm((prev) => ({
        ...prev,
        address: { ...prev.address, [key]: value },
      }));
    } else {
      setEditForm((prev) => ({ ...prev, [name]: value }));
    }
  };
  


  const handleContactInfoChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prevForm) => ({
      ...prevForm,
      contactInfo: {
        ...prevForm.contactInfo,
        [name]: value,
      },
    }));
  };

  return (
    <>
<Modal show={show} onHide={onHide} centered size="lg">
  <Modal.Header closeButton>
    <Modal.Title>Edit Shelter</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder="Enter shelter name"
              value={editForm.name}
              onChange={handleChange}
              disabled={loading}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Street</Form.Label>
            <Form.Control
              type="text"
              name="address.street"
              placeholder="Enter street"
              value={editForm.address?.street || "" }
              onChange={handleChange}
              disabled={loading}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>City</Form.Label>
            <Form.Control
              type="text"
              name="address.city"
              placeholder="Enter city"
              value={editForm.address?.city || ""}
              onChange={handleChange}
              disabled={loading}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Postal Code</Form.Label>
            <Form.Control
              type="text"
              name="address.postalCode"
              placeholder="Enter postal code"
              value={editForm.address?.postalCode || ""}
              onChange={handleChange}
              disabled={loading}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Country</Form.Label>
            <Form.Control
              type="text"
              name="address.country"
              placeholder="Enter country"
              value={editForm.address?.country || ""}
              onChange={handleChange}
              disabled={loading}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId="formPhone" className="mb-3">
          <Form.Label>Phone</Form.Label>
          <PhoneInput
  country={'de'} 
  inputClass="form-control"
  inputStyle={{ width: '100%' }}
  value={editForm.contactInfo.phone}
  onChange={(phone) => 
    setEditForm(prev => ({
      ...prev,
      contactInfo: { ...prev.contactInfo, phone }
    }))
  }
  disabled={loading}
/>

          </Form.Group>
        </Col>


      </Row>

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              placeholder="Enter email address"
              value={editForm.contactInfo.email}
              onChange={handleContactInfoChange}
              disabled={loading}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>State Coverage</Form.Label>
            <Form.Control
              type="text"
              name="stateCoverage"
              placeholder="Enter state coverage"
              value={editForm.stateCoverage}
              onChange={handleChange}
              disabled={loading}
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Cost Per Occupant</Form.Label>
            <Form.Control
              type="text"
              name="costPerOccupant"
              placeholder="Enter cost per occupant"
              value={editForm.costPerOccupant}
              onChange={handleChange}
              disabled={loading}
            />
          </Form.Group>
        </Col>
       
      </Row>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={onHide}>
      Close
    </Button>
    <Button variant="primary" onClick={handleSaveChanges} disabled={loading}>
      {loading ? <Spinner animation="border" size="sm" /> : "Save Changes"}
    </Button>
  </Modal.Footer>
</Modal>
 
     </>
  );
};

export default EditShelterModal;
